import { gql } from '@apollo/client';

// eslint-disable-next-line import/prefer-default-export
export const CHANGE_PASSWORD = gql`
    mutation ChangePassword(
        $o: String!, 
        $n: String!, 
        $r: String!
    ) {
        changePassword(
            o: $o, 
            n: $n, 
            r: $r
        ) {
            success
        }
    }
`;
